// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"736a7e3f1d1b63677e54","293":"c3f15cbd3648b3a7fb45"}[chunkId] + ".js";
};